// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f04c2265","453":"60ae9028","667":"801a977f"}[chunkId] + ".chunk.js";
};